export default "__VITE_ASSET__ea7ea224__"